var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 30.4001C15.0415 30.4001 11.5423 28.3734 9.49984 25.3334C9.54734 22.1667 15.8332 20.4251 18.9998 20.4251C22.1665 20.4251 28.4523 22.1667 28.4998 25.3334C27.4531 26.8921 26.0391 28.1694 24.3825 29.0529C22.7258 29.9365 20.8774 30.3991 18.9998 30.4001ZM18.9998 7.91675C20.2596 7.91675 21.4678 8.41719 22.3586 9.30799C23.2494 10.1988 23.7498 11.407 23.7498 12.6667C23.7498 13.9265 23.2494 15.1347 22.3586 16.0255C21.4678 16.9163 20.2596 17.4167 18.9998 17.4167C17.7401 17.4167 16.5319 16.9163 15.6411 16.0255C14.7503 15.1347 14.2498 13.9265 14.2498 12.6667C14.2498 11.407 14.7503 10.1988 15.6411 9.30799C16.5319 8.41719 17.7401 7.91675 18.9998 7.91675ZM18.9998 3.16675C16.9206 3.16675 14.8617 3.57629 12.9407 4.37199C11.0197 5.16769 9.27424 6.33396 7.80398 7.80422C4.83465 10.7735 3.1665 14.8008 3.1665 19.0001C3.1665 23.1993 4.83465 27.2266 7.80398 30.1959C9.27424 31.6662 11.0197 32.8325 12.9407 33.6282C14.8617 34.4239 16.9206 34.8334 18.9998 34.8334C23.1991 34.8334 27.2264 33.1653 30.1957 30.1959C33.165 27.2266 34.8332 23.1993 34.8332 19.0001C34.8332 10.2442 27.7082 3.16675 18.9998 3.16675Z",
    fill: "#E9474C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profileActive.77ce0fd18328a7d684ed211a3d1d19da.svg";
export { ForwardRef as ReactComponent };